var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C7.0189 0 8.39379 0.615433 9.38895 1.61106C10.3841 2.60621 11 3.98156 11 5.5C11 7.01844 10.3846 8.39379 9.38895 9.38895C8.39379 10.3841 7.01844 11 5.5 11C3.9811 11 2.60621 10.3846 1.61106 9.38895C0.615433 8.39379 0 7.01844 0 5.5C0 3.98156 0.615433 2.60621 1.61106 1.61106C2.60621 0.615433 3.9811 0 5.5 0ZM5.05035 2.78774C5.05035 2.6215 5.18511 2.48674 5.35135 2.48674C5.5176 2.48674 5.65235 2.6215 5.65235 2.78774V5.56622L7.7427 6.80542C7.88532 6.8897 7.93302 7.07401 7.84874 7.2171C7.76446 7.35973 7.58016 7.40743 7.43706 7.32315L5.21474 6.00568C5.11703 5.95567 5.05035 5.85426 5.05035 5.73756V2.78774ZM8.96337 2.03663C8.07704 1.15029 6.85266 0.602004 5.5 0.602004C4.14734 0.602004 2.92296 1.15029 2.03663 2.03663C1.15029 2.92296 0.602004 4.14734 0.602004 5.5C0.602004 6.85266 1.15029 8.07704 2.03663 8.96337C2.92296 9.84971 4.14734 10.398 5.5 10.398C6.85266 10.398 8.07704 9.84971 8.96337 8.96337C9.84971 8.07704 10.398 6.85266 10.398 5.5C10.398 4.14734 9.84971 2.92296 8.96337 2.03663Z",
    fill: "#1E40AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime1);
export default __webpack_public_path__ + "static/media/time1.f91d8797da945bdc82106e9324faf93c.svg";
export { ForwardRef as ReactComponent };